"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarButton = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var __1 = require("../..");
var FeedbackPrompt_styled_1 = require("./FeedbackPrompt.styled");
var copy_1 = require("./copy");
var Star = function (props) {
    var _a = (0, styled_components_1.useTheme)(), colors = _a.colors, borderWidths = _a.borderWidths;
    return (react_1.default.createElement("svg", __assign({ width: "24", height: "22", viewBox: "0 0 24 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M12 2.25955L14.63 7.58846L14.8626 8.05991L15.3829 8.1355L21.2637 8.99004L17.0083 13.138L16.6319 13.505L16.7207 14.0231L17.7253 19.8802L12.4653 17.1149L12 16.8702L11.5347 17.1149L6.27471 19.8802L7.27927 14.0231L7.36814 13.505L6.99167 13.138L2.73628 8.99004L8.61709 8.1355L9.13735 8.05991L9.37002 7.58846L12 2.25955Z", stroke: colors.primary, strokeWidth: borderWidths.heavy })));
};
exports.StarButton = (0, react_1.forwardRef)(function (_a, ref) {
    var rating = _a.rating, rest = __rest(_a, ["rating"]);
    var VisuallyHidden = (0, __1.useComponents)().VisuallyHidden;
    var Copy = (0, __1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(FeedbackPrompt_styled_1.StyledButton, __assign({}, rest, { ref: ref }),
        react_1.default.createElement(Star, null),
        react_1.default.createElement(VisuallyHidden, null,
            react_1.default.createElement(Copy, { copyKey: "feedbackPromptRatingLabel", values: {
                    total: 5,
                    rating: rating,
                } }))));
});
